var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 19 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "fmrne8g9ka",
    d: "M15 9L13.943 7.942 9.75 12.127 9.75 3 8.25 3 8.25 12.127 4.065 7.935 3 9 9 15z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-15 -13) translate(15.463 13)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "zedhaboqvb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fmrne8g9ka"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#zedhaboqvb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H37.5V37.5H0z",
    transform: "translate(-9.75 -9.75)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrow-icon.6cf6c8dde1ee4aa943cbb1134bc08339.svg";
export { ForwardRef as ReactComponent };